import PageHeading from './components/PageHeading';
import React from 'react';
import { Link } from 'react-router-dom';
import LogoTray from './components/LogoTray';
import './Search.css';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <LogoTray />

      <div className="about-content">
        <PageHeading eyebrow="O nama" title="Sve vijesti. Vaš izbor.">Jedno mjesto za pregled vijesti koji odgovara vama.</PageHeading>
        <section className="about-section">
          <h2>Dobrodošli na JaoSVE!</h2>
          <p>
            JaoSVE! je moderna platforma koja na jednom mjestu objedinjuje vijesti
            iz brojnih portala. Umjesto da svakodnevno otvarate desetine različitih sajtova,
            cijelu informativnu sliku dobijate kroz jedan jednostavan i pregledan prikaz.
          </p>
          <p>
            Glavna ideja JaoSVE! platforme je <strong>sloboda izbora</strong> — vi sami odlučujete
            šta želite čitati, iz kojih izvora i u kojem obliku. Sadržaj prilagođavate svojim
            potrebama, a ne obrnuto.
          </p>
        </section>

        <section className="about-section">
          <h2>Jednostavno, po vašoj mjeri</h2>
          <p>
            JaoSVE! vam daje slobodu da informativni pregled prilagodite sebi. Detaljne korake
            za pretragu, filtere, korisnički račun i ostale mogućnosti pronaći ćete u tabu
            <strong> „Kako koristiti“</strong>.
          </p>
        </section>

        <section className="about-section">
          <h2>Kontakt</h2>
          <div className="contact-info">
            <p><strong>Email:</strong> info@jaosve.com</p>
            <p><Link to="/privacy">Politika privatnosti</Link> · <Link to="/delete-account">Brisanje računa</Link></p>
          </div>
          <p>
            Otvoreni smo za prijedloge, primjedbe i sugestije. Ako vam neki portal nedostaje
            ili imate ideju kako JaoSVE! unaprijediti — javite nam se.
          </p>
        </section>
      </div>
    </div>
  );
}

export default About;
